const apiUrl = import.meta.env.VITE_API_URL?.replace(/\/$/, '') ?? '';
const useMock = import.meta.env.VITE_USE_MOCK_API !== 'false' && !apiUrl;

function deriveApiOrigin(url: string): string {
  if (!url) return '';
  return url.replace(/\/api\/?$/, '');
}

export const env = {
  apiUrl,
  apiOrigin: deriveApiOrigin(apiUrl),
  useMock,
  isDev: import.meta.env.DEV,
} as const;
